import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({ id: '', name: '', email: '', role: '', number: '', tenantId: '' });
  const [bookingsOrderID, setBookingsOrderID] = useState([]);
  const [particularDeliveryman, setParticularDeliveryman] = useState("");

  return (
    <UserContext.Provider value={{ user, setUser, bookingsOrderID, setBookingsOrderID , particularDeliveryman, setParticularDeliveryman }}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
